import React, { useRef, useState } from "react";
import { useAuth } from "./AuthContext";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { Stack, TextField, Button } from "@mui/material";
import AuthShell from "./AuthShell";
import googleSignInBtn from "./btn_google_signin_dark_normal_web@2x.png";

function SignInScreen() {
  const { currentUser, loginWithEmailPassword, loginWithRedirect } = useAuth();
  const navigate = useNavigate();
  const emailRef = useRef();
  const passwordRef = useRef();

  const [error, setError] = useState("");

  if (currentUser) {
    return <Navigate to="/" replace />;
  }

  const handleSignIn = async (event) => {
    event.preventDefault();
    setError("");

    try {
      await loginWithEmailPassword(
        emailRef.current.value,
        passwordRef.current.value
      );
      navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await loginWithRedirect();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to keep logging.">
      <form onSubmit={handleSignIn} className="auth-form">
        <Stack spacing={2}>
          <TextField
            size="small"
            label="Email"
            type="email"
            inputRef={emailRef}
            required
            fullWidth
          />
          <TextField
            size="small"
            label="Password"
            type="password"
            inputRef={passwordRef}
            required
            fullWidth
          />
          <Button variant="contained" type="submit">
            Continue
          </Button>
        </Stack>
      </form>

      {error && <div className="auth-error">{error}</div>}

      <div className="auth-divider">or</div>

      <button
        type="button"
        className="auth-google"
        onClick={handleGoogleSignIn}
      >
        <img src={googleSignInBtn} alt="Sign In with Google" />
      </button>

      <div className="auth-foot">
        <span>
          Don't have an account? <Link to="/signup">Sign up</Link>
        </span>
        <Link to="/forgotpassword">Forgot password?</Link>
      </div>
    </AuthShell>
  );
}

export default SignInScreen;
